import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Cell = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-width: 0;
  min-height: ${space[9]};
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  font-family: ${fonts.body};

  &[data-empty] {
    cursor: default;
    pointer-events: none;
  }

  &[data-blocked] {
    cursor: not-allowed;
    pointer-events: none;
  }

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    height: ${space[8]};
    transform: translateY(-50%);
    background: ${semantic.bg.surfaceSubtle};
    pointer-events: none;
    display: none;
  }

  &[data-in-range]::before {
    display: block;
    left: 0;
    right: 0;
  }

  &[data-in-range][data-row-start]::before {
    border-radius: ${layout.borderRadiusFull} 0 0 ${layout.borderRadiusFull};
  }

  &[data-in-range][data-row-end]::before {
    border-radius: 0 ${layout.borderRadiusFull} ${layout.borderRadiusFull} 0;
  }

  &[data-range-after]::before {
    display: block;
    left: 50%;
    right: 0;
  }

  &[data-range-after][data-row-end]::before {
    border-radius: 0 ${layout.borderRadiusFull} ${layout.borderRadiusFull} 0;
  }

  &[data-range-before]::before {
    display: block;
    left: 0;
    right: 50%;
  }

  &[data-range-before][data-row-start]::before {
    border-radius: ${layout.borderRadiusFull} 0 0 ${layout.borderRadiusFull};
  }
`;

export const DayIndicator = styled.span`
  position: relative;
  z-index: 1;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: ${space[8]};
  min-height: ${space[8]};
  padding: ${space[1]};
  border-radius: ${layout.borderRadiusFull};
  transition: background-color 0.15s ease;

  ${Cell}[data-selected] & {
    background: ${colors.primary};
    color: ${colors.white};
  }

  ${Cell}[data-today]:not([data-selected]) & {
    background: ${semantic.bg.surfaceSubtle};
  }

  ${Cell}[data-check-in-closed]:not([data-selected]) & {
    background: ${semantic.bg.surfaceSubtle};
  }

  ${Cell}[data-hoverable]:hover & {
    background: ${semantic.bg.surfaceStrong};
  }

  ${Cell}[data-blocked]:not([data-past]):not([data-selected]) & {
    background: ${semantic.bg.surfaceSubtle};
  }

  ${Cell}[data-selected][data-hoverable]:hover & {
    background: ${colors.primary};
  }
`;

export const DayNumber = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  line-height: 1.2;
  color: ${(p) => (p.$selected ? colors.white : semantic.text.primary)};

  ${Cell}[data-blocked] & {
    color: ${semantic.text.tertiary};
  }
`;

export const DayPrice = styled.span<{ $selected?: boolean }>`
  font-size: ${fonts.size.xxs};
  line-height: 1;
  color: ${(p) => (p.$selected ? colors.white : semantic.text.secondary)};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;
